import { connect } from 'react-redux';
import { createSelector, createStructuredSelector } from 'reselect';
import FrameworkUtils from 'utils/framework';
import LanguageLocaleUtils from 'utils/LanguageLocale';
import UseAGiftCard from 'components/FrictionlessCheckout/PaymentReleaseFour/GiftCards/UseAGiftCard/UseAGiftCard';
import checkoutApi from 'services/api/checkout';
import decorators from 'utils/decorators';
import { INTERSTICE_DELAY_MS } from 'constants/Checkout';
import store from 'store/Store';
import { refreshCheckout } from 'services/Checkout';
import PaymentEN from 'components/FrictionlessCheckout/PaymentReleaseFour/locales/Payment_en_US';
import PaymentFR from 'components/FrictionlessCheckout/PaymentReleaseFour/locales/Payment_fr_CA';

const { wrapHOC } = FrameworkUtils;
const { getTextFromResource, getLocalisedDataFromResource } = LanguageLocaleUtils;
const getText = getLocalisedDataFromResource(PaymentEN, PaymentFR);

const localization = createStructuredSelector({
    useGiftCard: getTextFromResource(getText, 'useGiftCard'),
    giftCard: getTextFromResource(getText, 'giftCard'),
    giftCardNumber: getTextFromResource(getText, 'giftCardNumber'),
    giftCardNumberPlaceholder: getTextFromResource(getText, 'giftCardNumberPlaceholder'),
    pin: getTextFromResource(getText, 'pin'),
    pinNumberPlaceholder: getTextFromResource(getText, 'pinNumberPlaceholder'),
    applyBtn: getTextFromResource(getText, 'applyBtn'),
    cancelBtn: getTextFromResource(getText, 'cancelBtn')
});

const fields = createSelector(localization, locales => {
    return {
        localization: locales
    };
});

const functions = {
    applyGiftCard: (giftCard, callback) => {
        return decorators
            .withInterstice(
                checkoutApi.applyGiftCard,
                INTERSTICE_DELAY_MS
            )(giftCard)
            .then(() => {
                store.dispatch(refreshCheckout());
                callback();
            });
    }
};

const withGiftCardProps = wrapHOC(connect(fields, functions));

export default withGiftCardProps(UseAGiftCard);
